'use strict';


module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/markdown-it/index.js
// module id = NP13
// module chunks = 0